import { useState } from "react";
import { ArrowRight, MessageSquare, X } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { ELink } from "./Editable";

// Bandeau « Nouveau : étapes par texto » (demande du propriétaire, 2026-11-03) —
// annonce la disponibilité des étapes de commande par texto (soumission,
// approbation, paiement, matrice). Même style que le bandeau forfaits ; masquable
// par le visiteur (X, mémorisé). Jamais « gravure incluse/comprise ».
export default function SmsBanner() {
  const { lang } = useLang();
  const [closed, setClosed] = useState(() => {
    try { return localStorage.getItem("bandeau_textos_closed") === "1"; } catch { return false; }
  });
  if (closed) return null;
  const dismiss = () => {
    try { localStorage.setItem("bandeau_textos_closed", "1"); } catch { /* noop */ }
    setClosed(true);
  };
  const fr = lang !== "en";
  return (
    <div data-testid="sms-banner"
      className="relative overflow-hidden border-y-2 border-emerald-500/50 bg-gradient-to-r from-emerald-500/20 via-[#0e241a] to-emerald-500/20 shadow-[0_0_28px_rgba(16,185,129,0.18)]">
      {/* balayage scintillant émeraude (décoratif) */}
      <div aria-hidden className="pointer-events-none absolute inset-0">
        <div className="bandeau-scintille-sms absolute -top-1/2 -bottom-1/2 w-1/3 bg-gradient-to-r from-transparent via-[rgba(167,243,208,0.35)] to-transparent" />
      </div>
      <style>{`
        @keyframes bandeau-scintille-sms {
          0% { transform: translateX(-160%) skewX(-20deg); opacity: 0; }
          12% { opacity: 1; }
          55% { transform: translateX(430%) skewX(-20deg); opacity: 1; }
          62% { opacity: 0; }
          100% { transform: translateX(430%) skewX(-20deg); opacity: 0; }
        }
        .bandeau-scintille-sms { animation: bandeau-scintille-sms 3.8s ease-in-out infinite; }
      `}</style>
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 py-4 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-center">
        <span className="inline-flex items-center gap-2.5 text-emerald-300">
          <MessageSquare className="w-5 h-5" />
          <strong className="font-serif text-lg">{fr ? "Nouveau : suivi par texto" : "New: order updates by text"}</strong>
        </span>
        <span className="text-sm text-ivory/85">
          {fr
            ? "Recevez les étapes de votre commande par texto — cochez la case dans la soumission."
            : "Get your order steps by text — tick the box in the quote form."}
        </span>
        <ELink editPath="link.sms_banner" to="/soumission-rapide" data-testid="sms-banner-cta"
          className="group inline-flex items-center gap-2 bg-emerald-500 text-ink font-bold px-6 py-2.5 rounded-full text-sm hover:shadow-[0_0_22px_rgba(110,231,183,0.5)] transition-all duration-300">
          {fr ? "Ma soumission en 30 s" : "My 30-second quote"}
          <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
        </ELink>
      </div>
      <button onClick={dismiss} data-testid="sms-banner-close" title={fr ? "Masquer" : "Dismiss"}
        className="absolute top-2.5 right-3 z-10 text-ivory/40 hover:text-emerald-300 transition-colors">
        <X size={16} />
      </button>
    </div>
  );
}
